var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartPredictionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.486 14.857a.514.514 0 0 1 .024 1.028H.514a.514.514 0 0 1-.024-1.027H15.486z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.24 9.404a3.193 3.193 0 0 0 1.333 2.346l.043.03a3.194 3.194 0 0 0 2.723.43l.004-.039a.4.4 0 0 1-.4.4H.8a.8.8 0 0 1-.8-.8v-2a.4.4 0 0 1 .176-.331zm6.691.336.395.388.043.041a3.19 3.19 0 0 0 2.803.818v1.184a.4.4 0 0 1-.4.4H6.228a.4.4 0 0 1-.4-.4v-.913c.073-.082.142-.168.206-.26l.896-1.258zm8.669-.369c.22 0 .4.18.4.4v2a.8.8 0 0 1-.8.8h-3.143a.4.4 0 0 1-.4-.4l.001-1.903c.206-.178.393-.386.555-.624l.186-.273H15.6zM2.674 4.685.822 7.287l-.03.043a3.209 3.209 0 0 0-.307.556H.4a.4.4 0 0 1-.4-.4v-2.4c0-.221.18-.4.4-.4l2.274-.001zm12.926 0c.22 0 .4.18.4.4v2.4a.4.4 0 0 1-.4.4h-2.19l1.807-2.656.03-.044c.105-.161.195-.328.268-.5h.085zM3.943 0c.22 0 .4.18.4.4l-.001 2.065c-.164.15-.316.32-.451.51l-.159.224L.4 3.2a.4.4 0 0 1-.4-.4v-2A.8.8 0 0 1 .8 0h3.143zM15.2 0a.8.8 0 0 1 .8.8v2a.4.4 0 0 1-.24.367A3.19 3.19 0 0 0 14.37.783a3.194 3.194 0 0 0-2.71-.422L11.658.4c0-.22.18-.4.4-.4H15.2zM9.771 0c.221 0 .4.18.4.4v.912c-.087.099-.17.205-.245.317l-.85 1.249-.336-.33-.043-.041a3.191 3.191 0 0 0-2.868-.805V.4c0-.22.179-.4.4-.4H9.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.627 2.786a1.143 1.143 0 0 1 1.908 1.257l-.019.028-3.004 4.416c-.394.58-1.21.67-1.72.196l-.025-.023-2.114-2.076L4.36 9.806c-.36.505-1.055.63-1.566.287l-.028-.02a1.143 1.143 0 0 1-.288-1.565l.02-.028 3.069-4.312a1.143 1.143 0 0 1 1.707-.176l.025.024L9.392 6.07l2.235-3.284z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPredictionIcon);
export default __webpack_public_path__ + "static/media/chart-prediction-icon.047b1238e57e583d5de3eeeed82d3882.svg";
export { ForwardRef as ReactComponent };